import React from 'react';
import {
  Flex,
  Box,
  Stack,
  Text,
  HStack,
  Icon,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Spinner,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiCalendar } from 'react-icons/fi';

/**
 * UpcomingEvents - Component to display upcoming events
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isLoading - Loading state
 * @param {Array} props.events - Events data array
 */
const UpcomingEvents = ({ isLoading, events = [] }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  
  // Determine border color based on event color
  const getBorderColor = (color) => {
    const colorMap = {
      'yellow': 'yellow.500',
      'blue': 'blue.500',
      'green': 'green.500',
      'red': 'red.500',
      'purple': 'purple.500',
      'orange': 'orange.500',
      'teal': 'teal.500',
      'cyan': 'cyan.500'
    };
    
    return colorMap[color] || 'gray.500';
  };
  
  // Get background color based on event color
  const getBgColor = (color) => {
    const colorMap = {
      'yellow': 'yellow.50',
      'blue': 'blue.50',
      'green': 'green.50',
      'red': 'red.50',
      'purple': 'purple.50',
      'orange': 'orange.50',
      'teal': 'teal.50',
      'cyan': 'cyan.50'
    };
    
    return colorMap[color] || 'gray.50';
  };
  
  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={0}>
        <Flex align="center">
          <Icon as={FiCalendar} mr={2} />
          <Heading size="md">Próximos Eventos</Heading>
        </Flex>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <Flex justify="center" py={6}>
            <Spinner />
          </Flex>
        ) : events && events.length > 0 ? (
          <Stack spacing={3}>
            {events.map((event, index) => (
              <Flex 
                key={index} 
                bg={getBgColor(event.color)} 
                p={3} 
                borderRadius="md" 
                borderLeft="4px solid" 
                borderLeftColor={getBorderColor(event.color)}
              >
                <Box flex="1">
                  <Text fontWeight="bold">{event.title}</Text>
                  <Text fontSize="sm">{event.description}</Text>
                  <HStack mt={2} fontSize="xs" color="gray.500">
                    <Icon as={FiCalendar} />
                    <Text>{event.date}</Text>
                  </HStack>
                </Box>
              </Flex>
            ))}
          </Stack>
        ) : (
          <Stack spacing={3}>
            <Flex bg="yellow.50" p={3} borderRadius="md" borderLeft="4px solid" borderLeftColor="yellow.500">
              <Box flex="1">
                <Text fontWeight="bold">Reunião de Diretoria</Text>
                <Text fontSize="sm">Discussão sobre expansão para novas cidades</Text>
                <HStack mt={2} fontSize="xs" color="gray.500">
                  <Icon as={FiCalendar} />
                  <Text>Amanhã, 10:00</Text>
                </HStack>
              </Box>
            </Flex>
            <Flex bg="blue.50" p={3} borderRadius="md" borderLeft="4px solid" borderLeftColor="blue.500">
              <Box flex="1">
                <Text fontWeight="bold">Lançamento de Nova Funcionalidade</Text>
                <Text fontSize="sm">Chat em tempo real entre contratantes e contratados</Text>
                <HStack mt={2} fontSize="xs" color="gray.500">
                  <Icon as={FiCalendar} />
                  <Text>12/05/2025, 15:30</Text>
                </HStack>
              </Box>
            </Flex>
            <Flex bg="green.50" p={3} borderRadius="md" borderLeft="4px solid" borderLeftColor="green.500">
              <Box flex="1">
                <Text fontWeight="bold">Fechamento Financeiro</Text>
                <Text fontSize="sm">Fechamento contábil do mês</Text>
                <HStack mt={2} fontSize="xs" color="gray.500">
                  <Icon as={FiCalendar} />
                  <Text>31/05/2025, 18:00</Text>
                </HStack>
              </Box>
            </Flex>
          </Stack>
        )}
      </CardBody>
    </Card>
  );
};

export default UpcomingEvents;